import {
    GET_USERNAME_CONTACT_SUGGESTION_SUCCESS,
    GET_USERNAME_CONTACT_SUGGESTION_FAILED,
    RESET_GET_USERNAME_CONTACT_SUGGESTION,
    LOADING_GET_USERNAME_CONTACT_SUGGESTION,
    NETWORK_ERROR_GET_USERNAME_CONTACT_SUGGESTION
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GET_USERNAME_CONTACT_SUGGESTION:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GET_USERNAME_CONTACT_SUGGESTION_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GET_USERNAME_CONTACT_SUGGESTION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GET_USERNAME_CONTACT_SUGGESTION:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GET_USERNAME_CONTACT_SUGGESTION:
            return (state = initialState);
        default:
            return state;
    }
};
